import styled from "styled-components";
import { Button } from "antd";
import { COLORS } from "../../constants/colors";

export const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
  position: relative;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 7px;
  align-items: center;

  @media (max-width: 768px) {
    width: 100%; /* Make buttons container take full width on mobile */
    justify-content: flex-start; /* Align buttons to the start on mobile */
  }
`;

export const FilterButton = styled(Button)`
  border-radius: 7px;
  padding: 20px;
  height: 46px;
  background-color: ${({ active }) => (active ? COLORS.$black : '#ffffff')};
  color: ${({ active }) => (active ? '#ffffff' : '#000000')};
  border: none;
  transition: background-color 0.3s, color 0.3s;

  &:hover, &:focus {
    background-color: ${({ active }) => (active ? COLORS.$black : '#e0e0e0')};
    color: ${({ active }) => (active ? '#ffffff' : '#000000')};
  }

  &:active {
    background-color: ${({ active }) => (active ? COLORS.$black : '#d0d0d0')};
    color: ${({ active }) => (active ? '#ffffff' : '#000000')};
  }

  @media (hover: none) {
    &:hover {
      background-color: ${({ active }) => (active ? COLORS.$black : '#ffffff')};
      color: ${({ active }) => (active ? '#ffffff' : '#000000')};
    }
  }

  -webkit-tap-highlight-color: transparent;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`;

export const CustomRangePicker = styled.div`
  position: absolute;
  z-index: 1000;
  top: calc(100% + 8px);
  left: 0;
  width: 100%;

  @media (max-width: 768px) {
    position: static; /* Allow the range picker to flow with other elements */
    display: block; /* Force the element to behave like a block for a new line */
    width: 100%; /* Make the range picker take the full width */
    margin-top: 16px; /* Add spacing between previous elements */
  }

  .ant-picker-calendar {
    width: 100%; /* Full width for calendar on mobile */
  }

  .ant-picker-panel-container {
    display: block;
    margin-top: 8px;

    @media (max-width: 768px) {
      width: 100%; /* Ensure the picker container is full width */
    }
  }
`;


export const RangePickerWrapper = styled.div`
  padding: 8px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  
  @media (max-width: 768px) {
    padding: 0;
    box-shadow: none;
    width: 100%;
  }

  .ant-picker {
    width: auto;
    
    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;